import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GiftCard } from '../models/giftcard';
import { Paging } from '../models/page';
import { ResponseModel } from '../models/response-model';
import { GiftCardFilter } from '../models/filters/giftcard-filter';
import { Filter } from '../models/filter';
import { DatePipe } from '@angular/common';
import { TIMESTAMP_PATTERN } from '../@core/constants';
import { GiftcardRequest } from '../models/request/giftcard-request';
import { GiftCardResponse } from '../models/response/giftcard-ressponse';
import { PaymentsRequestModel } from '../models/request/PaymentRequestModel';
import { Order } from '../models/order';

@Injectable({
  providedIn: 'root'
})
export class GiftCardService {
  simulateDummyOrder(giftCardNumber: string, request: GiftcardRequest) {
    return this.http.post<ResponseModel<Order>>(`${this.url}/${giftCardNumber}/dummyOrder`, request);
  }

  private url = `${environment.url}/giftCards`;

  constructor(private http: HttpClient, private datepipe: DatePipe) { }

  readGiftCard(cardNumber: string): Observable<ResponseModel<GiftCard>> {
    let params = new HttpParams();
    return this.http.get<ResponseModel<GiftCard>>(`${this.url}/${cardNumber}`, { params });
  }

  readGiftCards(filters: Filter<GiftCardFilter>): Observable<ResponseModel<Paging<Array<GiftCard>>>> {
    let params = new HttpParams();
    params = params.append("page", filters.page.toString());
    params = params.append("pageSize", filters.pageSize.toString());

    params = filters.value.creditNoteNumber ? params.append("creditNoteNumber", filters.value.creditNoteNumber) : params;
    params = filters.value.start ? params.append("start", this.datepipe.transform(filters.value.start, TIMESTAMP_PATTERN) ?? "") : params;
    params = filters.value.end ? params.append("end", this.datepipe.transform(filters.value.end, TIMESTAMP_PATTERN) ?? "") : params;
    params = filters.value.number ? params.append("number", filters.value.number) : params;
    params = filters.value.invoiceNumber ? params.append("invoiceNumber", filters.value.invoiceNumber) : params;
    return this.http.get<ResponseModel<Paging<Array<GiftCard>>>>(this.url, { params });
  }
  createGiftcard(request: GiftcardRequest) {
    return this.http.post<ResponseModel<GiftCardResponse>>(`${this.url}/fromList`, request);
  }

  createRefundGiftcard(cardNumber: string, request: GiftcardRequest) {
    return this.http.post<ResponseModel<GiftCard>>(`${this.url}/${cardNumber}/refund`, request);
  }
}
